import { useContext } from 'react';
import { EvaluationModalContext } from '@/components/EvaluationModal/context';

export const useEvaluationModal = () => {
  const context = useContext(EvaluationModalContext);

  if (!context) {
    throw new Error(
      'useEvaluationModal must be used inside EvaluationModalProvider',
    );
  }

  return context;
};
